import {
  candidateWorkQualitiesRequestData,
  candidateWorkQualitiesService,
} from "api";
import { Loader } from "components";
import { AssessmentWorkQualitiesUI } from "features";
import { getError, handleAssessmentTimer } from "helpers";
import { useToast, useApiRequest } from "hooks";
import { useMemo, useState } from "react";

interface AssessmentWorkQualitiesProps {
  callback: (metric: string) => void;
}

const AssessmentWorkQualities: React.FC<AssessmentWorkQualitiesProps> = ({
  callback,
}) => {
  // State
  const [startTime, setStartTime] = useState<number>(0);

  // Hooks
  const { openToast } = useToast();

  // API Request Hooks
  const { run, data: response, requestStatus, error } = useApiRequest({});

  const submit = (data) => {
    const candidate = localStorage.getItem("assessmentId");
    if (!candidate) return;
    const secondsLeft = parseInt(localStorage.getItem("secondsLeft") ?? "0");

    const submitData: candidateWorkQualitiesRequestData = {
      id: candidate,
      data: {
        question1: data.quality,
        question2: data.trait,
        minutes_left: Math.ceil(secondsLeft / 60),
      },
    };

    // Set start time
    setStartTime(new Date().getTime());
    run(candidateWorkQualitiesService(submitData));
  };

  useMemo(() => {
    if (response?.status === 201) {
      const data = response.data.data;
      const answered = parseInt(localStorage.getItem("answered") ?? "0");
      localStorage.setItem("answered", `${answered + 2}`);
      handleAssessmentTimer(startTime);
      callback("work_qualities");
    } else if (error) {
      handleAssessmentTimer(startTime);
      openToast({
        show: true,
        ...getError({
          error,
          text: "Failed to submit, please try again or contact support",
          heading: "Sorry",
        }),
        type: "error",
        timeOut: 5000,
      });
    }
  }, [response, error]);

  return (
    <>
      <Loader loading={requestStatus.isPending} />
      <AssessmentWorkQualitiesUI submit={submit} />
    </>
  );
};

export { AssessmentWorkQualities };
